import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export type NoteSnippet = {
  id: string;
  tenantId: string;
  storeId: string;
  createdBy: string;
  level: 'personal' | 'store';
  triggerCode: string;
  title: string;
  content: string;
  category: string | null;
  submittedForStore: boolean;
  submissionStatus: 'none' | 'pending' | 'approved' | 'rejected' | null;
  submittedAt: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  rejectionReason: string | null;
  useCount: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export type SnippetWithSubmitter = NoteSnippet & { submitterName: string };

export type CreateSnippetBody = {
  triggerCode: string;
  title: string;
  content: string;
  category?: string;
  level?: 'personal' | 'store';
};

export type PatchSnippetBody = {
  triggerCode?: string;
  title?: string;
  content?: string;
  category?: string | null;
};

export function listSnippets(params?: {
  level?: 'personal' | 'store' | 'all';
  category?: string;
  search?: string;
}): Promise<NoteSnippet[]> {
  return apiGet<NoteSnippet[]>('/api/v1/snippets', { params }).then((r) => r.data);
}

export function createSnippet(body: CreateSnippetBody): Promise<NoteSnippet> {
  return apiPost<NoteSnippet>('/api/v1/snippets', body).then((r) => r.data);
}

export function updateSnippet(id: string, body: PatchSnippetBody): Promise<NoteSnippet> {
  return apiPatch<NoteSnippet>(`/api/v1/snippets/${id}`, body).then((r) => r.data);
}

export function removeSnippet(id: string): Promise<void> {
  return apiDelete(`/api/v1/snippets/${id}`).then(() => undefined);
}

export function submitToStore(id: string): Promise<NoteSnippet> {
  return apiPost<NoteSnippet>(`/api/v1/snippets/${id}/submit-to-store`).then((r) => r.data);
}

export function pendingReview(): Promise<SnippetWithSubmitter[]> {
  return apiGet<SnippetWithSubmitter[]>('/api/v1/snippets/pending-review').then((r) => r.data);
}

export function reviewSnippet(
  id: string,
  body: { action: 'approve' | 'reject'; rejectionReason?: string },
): Promise<unknown> {
  return apiPost(`/api/v1/snippets/${id}/review`, body).then((r) => r.data);
}

export function useSnippet(id: string): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>(`/api/v1/snippets/${id}/use`).then((r) => r.data);
}
